import React, { useEffect, useMemo, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";

const Portfolio = () => {
  const isotope = useRef();
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const htmlElement = document.getElementsByTagName("html")[0];
  const isRtl = htmlElement.getAttribute("dir") === "rtl";

    const filters = {
    DETAILED: "پروژه‌های توسعه‌داده‌شده",
    MOCKUPS: "طراحی Prototype توسط تیم",
  };

  const types = {
    IMAGE: "image",
    VIDEO: "video",
    DOCUMENT: "document",
  };

  const sharedEngineeringStandards =
    "تمام ماژول‌ها با TypeScript پیاده‌سازی شده‌اند، از طریق RESTful APIهای مستندسازی‌شده در Postman ارائه می‌شوند و با CI/CD روی GitHub منتشر می‌شوند. استقرار با Docker Compose + Nginx انجام می‌شود و لایه امنیتی Production شامل OTP/JWT، RBAC برای عملیات Admin، Validation/Sanitization ورودی، ارتباط رمزنگاری‌شده (HTTPS)، Security Headerها و Audit Logging ساختاریافته است.";

  const globalProjects = [
    {
      title: "Pulsing (Goal-based Social Connection App)",
      slug: "pulsing",
      slugAliases: ["pulsing-demo"],
      type: types.DOCUMENT,
      previewLayout: "desktop",
      status: "منتشرشده و تحویل‌شده",
      role: "طراحی و توسعه محصول در تیم Pulsing",
      document: {
        challenge:
          "شروع ارتباط برای هدف مشخص، زمان و مکان مشترک معمولاً پراکنده و مبهم است و کاربر به مسیر روشنی برای پیدا کردن هم‌هدف نیاز دارد.",
        outcome:
          "محصول برای iOS و Android منتشر شد؛ کاربران می‌توانند پالس بسازند، افراد هم‌هدف را پیدا کنند و گفتگو را شروع کنند.",
        projectInfo:
          "Pulsing یک اپلیکیشن اجتماعی هدف‌محور است که افراد را بر اساس هدف، زمان و مکان مشترک به هم وصل می‌کند. این محصول از مرحله طراحی و توسعه عبور کرده، تحویل شده و نسخه‌های iOS و Android آن برای دانلود در دسترس‌اند.",
        client: "Pulsing Product Team",
        technologies: "SwiftUI, Kotlin, TypeScript, React, Node.js",
        industry: "اپلیکیشن اجتماعی iOS و Android",
        date: "2026",
        urls: [
          {
            name: "سایت رسمی",
            link: "https://pulsing.ir",
          },
          {
            name: "iOS - App Store",
            link: "https://apps.apple.com/app/id6803828017",
          },
          {
            name: "Android - کافه‌بازار",
            link: "https://cafebazaar.ir/app/com.app.pulsing",
          },
        ],
        sliderImages: [
          "images/projects/pulsing/screenshot-launched.png",
        ],
      },
      thumbImage: "images/projects/pulsing/main-launched.png",
      categories: [filters.DETAILED],
    },
    {
      title: "SimpleTemp (Mobile and Web-based Hiring Platform)",
      slug: "simpletemp-demo",
      type: types.DOCUMENT,
      previewLayout: "desktop",
      status: "Delivered",
      role: "Lead Developer، Project Manager و Contractor",
      document: {
        challenge:
          "کلینیک‌ها و متخصصان دندان‌پزشکی برای جذب نیروی موقت به مسیر سریع‌تر و ارتباط مستقیم نیاز داشتند.",
        outcome:
          "یک پلتفرم Web و Mobile برای ساده‌کردن جذب نیروی موقت و اتصال مستقیم کلینیک به متخصصان ارائه شد.",
        projectInfo:
          "SimpleTemp یک پلتفرم مدرن برای کلینیک‌های دندان‌پزشکی، Hygienistها و Dental Nurseها در لندن است. این محصول فرآیند جذب نیروی موقت را ساده می‌کند و کلینیک‌ها را مستقیم به متخصصان متصل می‌کند. در این پروژه Lead Developer بخش‌های iOS، Backend و Frontend بودم و همچنین نقش Project Manager و Contractor اصلی با کارفرما را برعهده داشتم.",
        client: "Soheil Kamali",
        technologies:
          "TypeScript, iOS, Android, Node.js, React, MongoDB, Swift, Kotlin, Stripe, Firebase",
        industry: "توسعه Web و Mobile App",
        date: "July 16, 2024",
        urls: [
          {
            name: "سایت رسمی",
            link: "http://simpletemp.co.uk",
          },
          {
            name: "iOS - App Store",
            link: "https://apps.apple.com/gb/app/simpletemp/id1631831946",
          },
          {
            name: "Android - Google Play",
            link: "https://play.google.com/store/apps/details?id=com.simpletempco.simpletemp&gl=UK",
          },
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/simpletemp-demo",
          },
        ],

        sliderImages: [
          "images/projects/simpletemp/sc4-01.png",
          "images/projects/simpletemp/sc4-02.png",
          "images/projects/simpletemp/1.png",
          "images/projects/simpletemp/2.png",
          "images/projects/simpletemp/3.png",
          "images/projects/simpletemp/4.png",
          "images/projects/simpletemp/5.png",
          "images/projects/simpletemp/6.png",
          "images/projects/simpletemp/7.png",
          "images/projects/simpletemp/8.png",
        ],
      },

      thumbImage: "images/projects/simpletemp/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "JobLoyal (Platform for Connecting Employers and Service Workers)",
      slug: "jobloyal-demo",
      type: types.DOCUMENT,
      previewLayout: "mobile",
      status: "Delivered",
      role: "توسعه‌ی Mobile و Backend",
      document: {
        challenge:
          "رزرو و مدیریت سرویس‌های خانگی به ارتباط سریع و لحظه‌ای میان مشتری و Service Provider نیاز داشت.",
        outcome:
          "یک Marketplace Real-Time برای اتصال مشتریان به Service Providerها و یکپارچه‌سازی رزرو و مدیریت سرویس توسعه داده شد.",
        projectInfo:
          "JobLoyal یک Marketplace سرویس‌های خانگی به‌صورت Real-Time است که برای iOS و Android به‌صورت Native ارائه شد. این پلتفرم مشتریان را به Service Providerها متصل می‌کند و فرآیند رزرو و مدیریت سرویس را یکپارچه می‌سازد. Backend با Node.js و PostgreSQL پیاده‌سازی شده و برای مقیاس‌پذیری بالا طراحی شده است.",
        client: "Mr. Serkan",
        technologies:
          "TypeScript, iOS, Android, Node.js, React, MongoDB, Swift, Kotlin, Firebase",
        industry: "توسعه Web و Mobile App",
        date: "October 16, 2022",
        urls: [
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/jobloyal-demo",
          },
        ],

        sliderImages: [
          "images/projects/jobloyal/sc4-01.png",
          "images/projects/jobloyal/sc4-02.png",
          "images/projects/jobloyal/1.jpg",
          "images/projects/jobloyal/2.jpg",
          "images/projects/jobloyal/3.jpg",
          "images/projects/jobloyal/4.jpg",
          "images/projects/jobloyal/5.jpg",
          "images/projects/jobloyal/6.jpg",
        ],
      },

      thumbImage: "images/projects/jobloyal/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "Radkit (IoT-based Home Automation System)",
      slug: "radbms-demo",
      slugAliases: ["radkit-demo"],
      type: types.DOCUMENT,
      status: "Delivered",
      role: "توسعه‌ی iOS و ارتباط با تجهیزات",
      document: {
        challenge:
          "کنترل تجهیزات خانه هوشمند باید هم روی شبکه‌ی محلی و هم از طریق اینترنت قابل‌دسترسی می‌بود.",
        outcome:
          "اپلیکیشن iOS با امکان کنترل تجهیزات از طریق TCP، UDP و MQTT پیاده‌سازی شد.",
        projectInfo:
          "Radkit یک راهکار هوشمند برای کنترل تجهیزات خانه هوشمند روی Local Network و اینترنت است. این پروژه با Swift در محیط Xcode توسعه داده شد و کنترل دستگاه‌ها را از طریق TCP/UDP و MQTT فراهم می‌کند.",
        client: "Radbms co.",
        technologies: "TypeScript, iOS, Swift, UIKit, MQTT, TCP, UDP, IoT, Xcode",
        industry: "توسعه Mobile App",
        date: "October 20, 2024",
        urls: [
          {
            name: "iOS - App Store",
            link: "https://apps.apple.com/us/app/radbms/id1599735488",
          },
          {
            name: "Android - APK",
            link: "https://imaxbms.com/files",
          },
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/radkit-demo",
          },
        ],

        sliderImages: [
          "images/projects/radkit/sc4-01.png",
          "images/projects/radkit/sc4-02.png",
          "images/projects/radkit/1.png",
          "images/projects/radkit/2.png",
          "images/projects/radkit/3.png",
          "images/projects/radkit/4.png",
          "images/projects/radkit/5.png",
          "images/projects/radkit/6.png",
          "images/projects/radkit/7.png",
          "images/projects/radkit/8.png",
        ],
      },

      thumbImage: "images/projects/radkit/main.png",
      categories: [filters.DETAILED],
    },
    {
      title:
        "I Heart Saving (E-commerce App for Local Shopping and Exclusive Discounts)",
      slug: "iheartsaving-demo",
      type: types.DOCUMENT,
      status: "Demo",
      role: "توسعه‌ی اپلیکیشن iOS",
      document: {
        projectInfo:
          "I Heart Saving یک اپلیکیشن E-commerce نمونه است که مدل عضویت سالانه برای تخفیف‌ها و پیشنهادهای اختصاصی را نمایش می‌دهد و با تمرکز بر خرید محلی، به کاهش هزینه کاربران کمک می‌کند.",
        client: "iHeartSaving co.",
        technologies: "TypeScript, iOS, Swift, UIKit, Xcode, In-App Purchases",
        industry: "توسعه Mobile App",
        date: "Sep 16, 2019",
        urls: [
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/iheartsaving-demo",
          },
        ],

        sliderImages: [
          "images/projects/iHeartsaving/1.png",
          "images/projects/iHeartsaving/2.png",
          "images/projects/iHeartsaving/3.png",
          "images/projects/iHeartsaving/4.png",
          "images/projects/iHeartsaving/5.png",
        ],
      },

      thumbImage: "images/projects/iHeartsaving/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "Emmanuel (Online Confectionery Store)",
      slug: "emmanuel-demo",
      type: types.DOCUMENT,
      previewLayout: "desktop",
      status: "Demo",
      role: "توسعه‌ی Web و Mobile",
      document: {
        projectInfo:
          "Emmanuel یک فروشگاه آنلاین شیرینی در بریتانیا است که برای تجربه خرید روان و سریع طراحی شد. این پروژه به‌صورت Demo، یک پلتفرم کامل E-commerce را با امکانات مدرن برای مرور، مقایسه و خرید محصولات ارائه می‌کند.",
        client: "Emmanuel co.",
        technologies:
          "TypeScript, Node.js, React, PostgreSQL, Express, Redux, JWT, Material UI, Stripe, Swift, iOS Development, Android Development",
        industry: "توسعه Mobile App",
        date: "August 16, 2019",
        urls: [
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/emmanuel-demo",
          },
        ],

        sliderImages: [
          "images/projects/emmanuel/1.jpg",
          "images/projects/emmanuel/2.jpg",
          "images/projects/emmanuel/3.jpg",
          "images/projects/emmanuel/4.jpg",
          "images/projects/emmanuel/5.jpg",
          "images/projects/emmanuel/6.jpg",
          "images/projects/emmanuel/7.jpg",
        ],
      },

      thumbImage: "images/projects/emmanuel/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "HonistAI (Telegram-based AI Chat Super App for iOS)",
      slug: "honistai-demo",
      type: types.DOCUMENT,
      previewLayout: "mobile",
      document: {
        projectInfo:
          "HonistAI یک Telegram Client پیشرفته و غیررسمی است که با الهام از Nicegram و بر پایه معماری Telegram iOS v12 ساخته شده است. اپلیکیشن iOS با Swift + UIStoryboard (iOS 26) توسعه داده شده و یک لایه دستیار مبتنی بر OpenAI به پیام‌رسانی اضافه می‌کند که رفتار آن داخل اپ مشابه ChatGPT است. AI Assistantها و Prompt Templateها در Backend Panel تعریف می‌شوند و به‌صورت داینامیک در اختیار End User قرار می‌گیرند. مدل درآمدی با Apple In-App Purchase (Subscription و One-Time Pack) و اقتصاد GEM پیاده‌سازی شده است؛ برای مثال 5 دلار به 200 GEM تبدیل می‌شود و مصرف براساس Token Usage انجام می‌گیرد. این پلتفرم از Google Ads در جریان گفتگو نیز پشتیبانی می‌کند و تنظیمات آن از سمت Admin قابل کنترل است. این نسخه در مرحله Pre-Launch قرار دارد و هنوز URL عمومی رسمی منتشر نشده است. " +
          sharedEngineeringStandards,
        client: "HonistAI Product Team",
        technologies:
          "TypeScript, Swift, UIStoryboard, iOS 26, Node.js, PostgreSQL, OpenAI API, Apple In-App Purchase, Google Ads, Firebase",
        industry: "پلتفرم AI Messaging و Mobile",
        date: "May 2025",
        urls: [
          {
            name: "وضعیت",
            link: "https://sinakhanjani.com/honistai-demo",
          },
        ],
        sliderImages: [
          "images/projects/honistai/1.png",
          "images/projects/honistai/2.png",
          "images/projects/honistai/3.png",
          "images/projects/honistai/4.png",
          "images/projects/honistai/5.png",
          "images/projects/honistai/6.png",
          "images/projects/honistai/7.png",
        ],
      },
      thumbImage: "images/projects/honistai/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "VegalyX (30-Second BTC Prediction & Settlement Platform)",
      slug: "vegalyx-demo",
      type: types.DOCUMENT,
      previewLayout: "desktop",
      document: {
        projectInfo:
          "VegalyX یک پلتفرم Web Trading با ماهیت High-Frequency است که روی راندهای 30 ثانیه‌ای پیش‌بینی قیمت Bitcoin تمرکز دارد. کاربر پیش‌بینی می‌کند قیمت در پایان راند بالاتر می‌بندد یا پایین‌تر؛ سپس نقدینگی سمت بازنده به‌صورت خودکار بین Positionهای برنده توزیع می‌شود. کل Stack با TypeScript ساخته شده است: Backend با Node.js + PostgreSQL، Frontend به‌صورت React PWA و Dashboard ادمین با React. رفتار Real-Time با Socket.IO برای Wallet Balance، پرداخت‌های On-Chain، Online Chat، Leaderboard، Market Tick و Settlement Event پیاده‌سازی شده است. قیمت BTC از Binance دریافت و به‌صورت لحظه‌ای Broadcast می‌شود. عملیات Deposit/Withdraw کیف پول با Tatum یکپارچه است و Auto-Processing برای TRC20/ERC20/BEP20 را پوشش می‌دهد. برای تضمین صحت مالی، طراحی تراکنش‌ها بر پایه ACID انجام شده و برای Push Notification از Firebase استفاده می‌شود. زیرساخت روی Google Cloud مستقر شده و تحویل نسخه‌ها با معماری Containerized و GitHub CI/CD خودکار انجام می‌گیرد. " +
          sharedEngineeringStandards,
        client: "VegalyX Product Team",
        technologies:
          "TypeScript, Node.js, PostgreSQL, React, PWA, Socket.IO, Binance Market Data, Tatum, Firebase, Google Cloud, Docker, Nginx",
        industry: "پلتفرم FinTech / Crypto Trading",
        date: "May 2025",
        urls: [
          {
            name: "سایت رسمی",
            link: "https://vegalyx.com",
          },
          {
            name: "دموی آنلاین",
            link: "https://demo.vegalyx.com",
          },
        ],
        sliderImages: [
          "images/projects/vegalyx/1.png",
          "images/projects/vegalyx/2.jpg",
          "images/projects/vegalyx/3.png",
          "images/projects/vegalyx/4.png",
          "images/projects/vegalyx/5.png",
          "images/projects/vegalyx/6.png",
          "images/projects/vegalyx/7.png",
          "images/projects/vegalyx/8.png",
          "images/projects/vegalyx/9.png",
          "images/projects/vegalyx/10.png",
          "images/projects/vegalyx/11.png",
        ],
      },
      thumbImage: "images/projects/vegalyx/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "Talkyo (Autonomous Social DM AI Agent Platform)",
      slug: "talkyo-demo",
      type: types.DOCUMENT,
      previewLayout: "desktop",
      document: {
        projectInfo:
          "Talkyo یک پلتفرم SaaS در حال توسعه برای ساخت AI Agentهای خودکار در Social Inbox است (مثل DM در Instagram/Facebook). MVP بر پایه OpenAI API ساخته شده و با یک Self-Learning Pipeline شروع می‌شود: بعد از اتصال اکانت بیزینسی، داده‌های پست/ریل/پروفایل از Graph API جمع‌آوری می‌شود، Context ساختاریافته ساخته می‌شود و رفتار پاسخ‌گویی بدون نیاز به Prompt پیچیده دستی شکل می‌گیرد. در Runtime نیز دستیار AI پیام‌ها را با Intent Routing، Fallback Policy امن و Escalation آماده Handoff مدیریت می‌کند. معماری بر مبنای RAG + Embeddings + Vector Search طراحی شده است. " +
          sharedEngineeringStandards,
        client: "Talkyo Product Team",
        technologies:
          "TypeScript, Node.js, PostgreSQL, React, OpenAI API, Vector Search, RAG, Instagram/Facebook Graph API, Webhooks, Docker, Nginx",
        industry: "اتوماسیون AI / Social Commerce",
        date: "2026 (In Development)",
        urls: [
          {
            name: "سایت اصلی",
            link: "https://talkyo.app",
          },
          {
            name: "داشبورد کاربر",
            link: "https://my.talkyo.app",
          },
        ],
        sliderImages: [
          "images/projects/talkyo/1.png",
          "images/projects/talkyo/2.png",
          "images/projects/talkyo/3.png",
          "images/projects/talkyo/4.png",
          "images/projects/talkyo/5.png",
          "images/projects/talkyo/6.png",
          "images/projects/talkyo/7.png",
        ],
      },
      thumbImage: "images/projects/talkyo/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "Paira (Subscription-based iOS Matchmaking Platform)",
      slug: "paira-demo",
      type: types.DOCUMENT,
      previewLayout: "mobile",
      document: {
        projectInfo:
          "Paira یک پلتفرم مدرن Matchmaking است با Backend مبتنی بر Node.js، داشبورد Admin با React و Frontend وب با Next.js به‌همراه اپلیکیشن Native iOS 26. مدل درآمدی شامل Apple In-App Purchase Subscription و بسته‌های تک‌خریدی است. پیام‌رسانی Real-Time در iOS با Firebase Realtime Database پیاده‌سازی شده و کنترل Identity/Authorization در Backend انجام می‌شود. سیستم امتیازدهی Matchmaking و Push Notification نیز برای بهبود Engagement در نظر گرفته شده است. " +
          sharedEngineeringStandards,
        client: "Paira Product Team",
        technologies:
          "TypeScript, Node.js, PostgreSQL, React, Next.js, Swift (iOS 26), Apple In-App Purchase, Firebase Realtime Database, Firebase Cloud Messaging",
        industry: "Social Networking / Dating App",
        date: "2026",
        urls: [
          {
            name: "وب‌سایت",
            link: "https://paira.me",
          },
        ],
        sliderImages: [
          "images/projects/paira/1.png",
          "images/projects/paira/2.png",
          "images/projects/paira/4.png",
          "images/projects/paira/5.jpeg",
          "images/projects/paira/6.jpeg",
          "images/projects/paira/7.jpeg",
          "images/projects/paira/8.png",
          "images/projects/paira/9.png",
          "images/projects/paira/10.png",
          "images/projects/paira/11.png",
          "images/projects/paira/12.png",
          "images/projects/paira/13.png",
          "images/projects/paira/14.jpeg",
        ],
      },
      thumbImage: "images/projects/paira/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "Women Health (Web & App)",
      type: types.IMAGE,
      document: {
        designer: "Mr. Aliabadi (Team UI/UX Designer)",
        industry: "طراحی Web و App",
        urls: [
          {
            name: "پروفایل Mr. Aliabadi",
            link: "https://dribbble.com/Hoseinaliabadi",
          },
        ],

        sliderImages: ["images/projects/hossein/healthapp-mobile.jpg"],
      },
      thumbImage: "images/projects/hossein/healthapp.jpg",

      categories: [filters.MOCKUPS],
    },
    {
      title: "Online Taxi Services",
      type: types.IMAGE,
      document: {
        designer: "Mr. Aliabadi (Team UI/UX Designer)",
        industry: "طراحی App",
        urls: [
          {
            name: "پروفایل Mr. Aliabadi",
            link: "https://dribbble.com/Hoseinaliabadi",
          },
        ],

        sliderImages: [],
      },
      thumbImage: "images/projects/hossein/online-taxi.jpg",

      categories: [filters.MOCKUPS],
    },
  ];

  const persianOnlyProjects = [
    {
      title: "Mahzareghanoon (Iranian Lawbook Super App)",
      slug: "mahzareghanoon-demo",
      type: types.DOCUMENT,
      previewLayout: "mobile",
      document: {
        projectInfo:
          "Mahzareghanoon یک پلتفرم جامع کتاب‌های حقوقی ایران با Backend مبتنی بر Node.js، پایگاه داده PostgreSQL و اپلیکیشن Flutter برای iOS/Android است. سیستم از OTP Authentication، Firebase Notification، Highlight متن و دسته‌بندی نامحدود محتوای حقوقی در پنل React Admin پشتیبانی می‌کند. قابلیت کلیدی آن Offline-First Legal Delivery است: کتابخانه‌های حقوقی تعریف‌شده در Backend به‌صورت Bundle فشرده دیتابیس به اپ ارسال می‌شوند، در دیتابیس محلی Extract شده و با Incremental Update همگام می‌شوند. " +
          sharedEngineeringStandards,
        client: "Mahzareghanoon Team",
        technologies:
          "TypeScript, Node.js, PostgreSQL, Flutter (iOS/Android), React Admin, Firebase, OTP Auth, Offline Sync Engine",
        industry: "پلتفرم LegalTech / Mobile Knowledge",
        date: "2025",
        urls: [
          {
            name: "سایت رسمی",
            link: "https://mahzareghanoon.com",
          },
        ],
        sliderImages: [
          "images/projects/mahzareghanoon/1.jpg",
          "images/projects/mahzareghanoon/2.jpg",
          "images/projects/mahzareghanoon/3.jpg",
          "images/projects/mahzareghanoon/4.jpg",
          "images/projects/mahzareghanoon/5.jpg",
          "images/projects/mahzareghanoon/6.jpg",
          "images/projects/mahzareghanoon/7.jpg",
          "images/projects/mahzareghanoon/8.png",
          "images/projects/mahzareghanoon/9.png",
          "images/projects/mahzareghanoon/10.jpg",
          "images/projects/mahzareghanoon/12.png",
          "images/projects/mahzareghanoon/13.jpg",
          "images/projects/mahzareghanoon/14.jpg",
          "images/projects/mahzareghanoon/15.jpg",
          "images/projects/mahzareghanoon/16.jpg",
          "images/projects/mahzareghanoon/17.jpg",
        ],
      },
      thumbImage: "images/projects/mahzareghanoon/main.png",
      categories: [filters.DETAILED],
    },
    /*
    {
      title: "OSXVPN VPN",
      slug: "osxvpn-demo",
      type: types.DOCUMENT,
      previewLayout: "desktop",
      document: {
        projectInfo:
          "OSXVPN یک پلتفرم اشتراک VPN کاملاً خودکار است که با JavaScript توسعه داده شد؛ Backend آن Node.js و دیتابیس آن PostgreSQL است. Frontend با React.js پیاده‌سازی شده و این پروژه به‌صورت Solo Development توسط من در Backend، Frontend و تنظیمات Server اجرا شده است.",
        client: "osxvpn group.",
        technologies:
          "node.js, react, ibsng, postgresql, express, jwt, L2TP/IPSec, openVPN, Cisco VPN, restful API",
        industry: "توسعه Web",
        date: "Nov 16, 2023",
        urls: [
          {
            name: "سایت رسمی",
            link: "https://osxnetwork.top",
          },
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/osxvpn-demo",
          },
        ],

        sliderImages: ["images/projects/osxvpn/1.png", "images/projects/osxvpn/2.png"],
      },

      thumbImage: "images/projects/osxvpn/main.png",
      categories: [filters.DETAILED],
    },
    */
    {
      title: "Ostovaneh",
      slug: "ostovaneh-demo",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "Ostovaneh یک کتابخانه محتوای Multimedia به‌صورت Cross-Platform است که دسترسی به Audio Book، Video و کتاب متنی رمزنگاری‌شده را فراهم می‌کند. برای امنیت محتوا، داده در Server رمز می‌شود و هنگام دریافت از API در اپ Decrypt می‌گردد.",
        client: "Mr. Tofighi",
        technologies:
          "node.js, react, postgresql, express.js, jwt, iOS Development, Swift, XCode",
        industry: "توسعه Mobile App",
        date: "March 16, 2021",
        urls: [
          {
            name: "iOS - Sibirani",
            link: "https://sibirani.com/apps/Ostovaneh/",
          },
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/ostovaneh-demo",
          },
        ],

        sliderImages: [
          "images/projects/ostovaneh/2.jpg",
          "images/projects/ostovaneh/3.jpg",
          "images/projects/ostovaneh/4.jpg",
          "images/projects/ostovaneh/5.jpg",
          "images/projects/ostovaneh/6.jpg",
          "images/projects/ostovaneh/7.jpg",
          "images/projects/ostovaneh/8.jpg",
        ],
      },

      thumbImage: "images/projects/ostovaneh/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "Course App",
      type: types.IMAGE,
      document: {
        designer: "Mr. Aliabadi (Team UI/UX Designer)",
        industry: "طراحی Material برای Web",
        urls: [
          {
            name: "پروفایل Mr. Aliabadi",
            link: "https://dribbble.com/Hoseinaliabadi",
          },
        ],

        sliderImages: [],
      },
      thumbImage: "images/projects/hossein/smartai.jpg",

      categories: [filters.MOCKUPS],
    },
    {
      title: "Glasor (Streamline communication between students & teachers)",
      slug: "glasor-demo",
      type: types.DOCUMENT,
      previewLayout: "mobile",
      document: {
        projectInfo:
          "Glasor یک اپلیکیشن Mobile برای بهینه‌سازی ارتباط بین دانش‌آموز، معلم و والدین است. این محصول به‌صورت Native برای iOS و Android توسعه یافت و Backend آن با Node.js پیاده‌سازی شد تا ارتباط Real-Time و دسترسی به اطلاعات آموزشی بهبود پیدا کند.",
        client: "Mr. Ameri",
        technologies:
          "python, next.js, postgresql, django, jwt, iOS Development, Android Development, Kotlin, Swift, XCode, restful API",
        industry: "توسعه Mobile App",
        date: "March 16, 2020",
        urls: [
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/glasor-demo",
          },
        ],

        sliderImages: [
          "images/projects/glasor/1.jpeg",
          "images/projects/glasor/2.jpeg",
          "images/projects/glasor/3.jpeg",
          "images/projects/glasor/4.jpeg",
          "images/projects/glasor/5.jpeg",
          "images/projects/glasor/6.jpeg",
        ],
      },

      thumbImage: "images/projects/glasor/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "Cario (Your Personal Car Assistant)",
      slug: "cario-demo",
      type: types.DOCUMENT,
      previewLayout: "mobile",
      document: {
        projectInfo:
          "Cario یک Mobile App برای کمک به صاحبان خودرو در کارهای روزمره مرتبط با نگهداری و سرویس خودرو است و نقش یک دستیار دیجیتال برای مدیریت بهتر امور خودرو را ایفا می‌کند.",
        client: "Mr. Rahimi",
        technologies:
          "Python, Django, React, postgresql, jwt, iOS Development, Android Development, Kotlin, Swift, Google Map",
        industry: "توسعه Mobile App",
        date: "Dec 30, 2017",
        urls: [
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/cario-demo",
          },
        ],

        sliderImages: [
          "images/projects/cario/1.jpg",
          "images/projects/cario/2.jpg",
          "images/projects/cario/3.jpg",
          "images/projects/cario/4.jpg",
          "images/projects/cario/5.jpg",
        ],
      },

      thumbImage: "images/projects/cario/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "Academy App",
      type: types.IMAGE,
      document: {
        designer: "Mr. Aliabadi (Team UI/UX Designer)",
        industry: "طراحی Material برای Web",
        urls: [
          {
            name: "پروفایل Mr. Aliabadi",
            link: "https://dribbble.com/Hoseinaliabadi",
          },
        ],

        sliderImages: [],
      },
      thumbImage: "images/projects/hossein/academy.jpg",

      categories: [filters.MOCKUPS],
    },
    {
      title: "Bisim App",
      slug: "bisimapp-demo",
      type: types.DOCUMENT,
      previewLayout: "mobile",
      document: {
        projectInfo:
          "Bisim App یک اپلیکیشن Ride-Hailing مشابه Uber است که مسافر را در لحظه به راننده متصل می‌کند. کاربر مبدا را روی نقشه انتخاب می‌کند و راننده‌های نزدیک درخواست را می‌پذیرند. نسخه اولیه پروژه برای iOS با Swift و Xcode توسعه داده شد.",
        client: "Mr. Ranjbar",
        technologies: "socket.io, jwt, iOS Development, Swift, GSK Map, UIKit",
        industry: "توسعه Mobile App",
        date: "Dec 30, 2018",
        urls: [
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/bisimappp-demo",
          },
        ],

        sliderImages: [
          "images/projects/bisimapp/1.jpeg",
          "images/projects/bisimapp/2.jpeg",
          "images/projects/bisimapp/3.jpeg",
          "images/projects/bisimapp/4.jpeg",
          "images/projects/bisimapp/5.jpeg",
          "images/projects/bisimapp/6.jpeg",
          "images/projects/bisimapp/7.jpeg",
          "images/projects/bisimapp/8.jpeg",
        ],
      },

      thumbImage: "images/projects/bisimapp/main.png",
      categories: [filters.DETAILED],
    },
    {
      title: "Course App",
      type: types.IMAGE,
      document: {
        designer: "Mr. Aliabadi (Team UI/UX Designer)",
        industry: "طراحی Material برای Web",
        urls: [
          {
            name: "پروفایل Mr. Aliabadi",
            link: "https://dribbble.com/Hoseinaliabadi",
          },
        ],

        sliderImages: [],
      },
      thumbImage: "images/projects/hossein/course.jpg",

      categories: [filters.MOCKUPS],
    },
    {
      title: "Nerkh",
      slug: "nerkh-demo",
      type: types.DOCUMENT,
      previewLayout: "mobile",
      document: {
        projectInfo:
          "Nerkh یک اپلیکیشن Demo برای نمایش Real-Time نرخ ارزهای مختلف است که با رابط کاربری ساده، امکان مشاهده، تحلیل و پیگیری تغییرات قیمت ارز را فراهم می‌کند.",
        client: "Mr. Khanjani",
        technologies: "Swift, UIKit, XCode, Python, Django, Restful API",
        industry: "توسعه iOS App",
        date: "Feb 30, 2016",
        urls: [
          {
            name: "GitHub - Demo",
            link: "https://github.com/sinakhanjani/nerkh-ios-native-app",
          },
        ],

        sliderImages: [
          "images/projects/nerkh/1.jpg",
          "images/projects/nerkh/2.jpg",
          "images/projects/nerkh/3.jpg",
          "images/projects/nerkh/4.jpg",
          "images/projects/nerkh/5.jpg",
        ],
      },

      thumbImage: "images/projects/nerkh/main.png",
      categories: [filters.DETAILED],
    },
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const projectsData = useMemo(() => [...globalProjects, ...persianOnlyProjects], []);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  const getKeyByValue = (value) => {
    return Object.keys(filters).find((key) => filters[key] === value);
  };

  const getFilterClasses = (categories) => {
    if (categories.length > 0) {
      const tempArray = [];
      categories.forEach((category) => {
        tempArray.push(getKeyByValue(category));
      });
      return tempArray.join(" ");
    }
    return "";
  };

  const openProjectModal = (project, updateUrl = true) => {
    setSelectedProjectDetails(project);
    setIsOpen(true);
    if (updateUrl && project?.slug && window.location.pathname !== `/${project.slug}`) {
      window.history.pushState({}, "", `/${project.slug}`);
    }
  };

  const closeProjectModal = () => {
    setIsOpen(false);
    if (window.location.pathname !== "/") {
      window.history.pushState({}, "", "/");
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      originLeft: !isRtl,
    });

    return () => {
      isotope.current.destroy();
    };
  }, [isRtl]);

  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  useEffect(() => {
    const findProjectBySlug = (slug) => {
      if (!slug) return null;
      const normalizedSlug = slug.toLowerCase();
      return projectsData.find(
        (project) =>
          project.slug === normalizedSlug ||
          project.slugAliases?.map((item) => item.toLowerCase()).includes(normalizedSlug)
      );
    };

    const openProjectFromPath = () => {
      const path = window.location.pathname.replace(/^\/+|\/+$/g, "");
      if (!path) return;
      const matchedProject = findProjectBySlug(path);
      if (matchedProject) {
        openProjectModal(matchedProject, false);
        document.getElementById("portfolio")?.scrollIntoView({ behavior: "smooth" });
      }
    };

    openProjectFromPath();
    window.addEventListener("popstate", openProjectFromPath);

    return () => {
      window.removeEventListener("popstate", openProjectFromPath);
    };
  }, [projectsData]);

  return (
    <>
      <section id="portfolio" className={"section bg-light"}>
        <div className={"container"}>
          <p className="text-center mb-2 wow fadeInUp">
            <span className="bg-primary text-dark px-2">پروژه‌ها</span>
          </p>
          <h2 className="text-10 fw-600 text-center mb-3 wow fadeInUp">
            پروژه‌هایی که می‌شود درباره‌شان دقیق صحبت کرد
          </h2>
          <p className="text-muted text-center text-5 mb-5 wow fadeInUp">
            بخشی از پروژه‌ها، محصولات تحویل‌شده و بخشی Prototype یا Demo هستند؛ وضعیت هر پروژه شفاف مشخص شده است.
          </p>

          <ul
            className={
              "portfolio-menu nav nav-tabs fw-600 justify-content-start justify-content-md-center border-bottom-0 mb-5 wow fadeInUp"
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                همه
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={"nav-link " + (filterKey === oneKey ? "active" : "")}
                  onClick={handleFilterKeyChange(oneKey)}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>

          <div className="portfolio wow fadeInUp">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " + getFilterClasses(project.categories)
                    }
                    key={index}
                  >
                    <div className="portfolio-box">
                      <div
                        className={`portfolio-img ${
                          project.type === types.DOCUMENT && project.previewLayout
                            ? `portfolio-img--${project.previewLayout}`
                            : ""
                        }`}
                      >
                        <img
                          onLoad={() => {
                            setImagesLoaded((prev) => prev + 1);
                          }}
                          className={`img-fluid d-block portfolio-image ${
                            project.type === types.DOCUMENT && project.previewLayout
                              ? `portfolio-image--${project.previewLayout}`
                              : ""
                          }`}
                          src={project.thumbImage}
                          alt={project.title}
                        />
                        <div
                          className="portfolio-overlay"
                          onClick={() => {
                            openProjectModal(project, true);
                          }}
                        >
                          <button className="popup-ajax stretched-link border-0 p-0 "> </button>
                          <div className="portfolio-overlay-details">
                            <p className="text-primary text-8">
                              {project.type === types.DOCUMENT && <i className="fas fa-file-alt"></i>}
                              {project.type === types.IMAGE && <i className="fas fa-image"></i>}
                              {project.type === types.VIDEO && <i className="fas fa-video"></i>}
                            </p>
                            <h5 className="text-white text-5">{project?.title}</h5>
                            {project.status && <span className="text-light">{project.status}</span>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>

      {isOpen && (
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          onClose={closeProjectModal}
        ></ProjectDetailsModal>
      )}
    </>
  );
};

export default Portfolio;
